<template>
	<div 
		id="Screen"
		class="Screen"
		@click="clickTapBuzz()"
	>
		<div id="bgContainer1" v-if="currentState === STATE_WAIT_TO_START">
			<div  
				v-if="showBg1 === true" 
				id="bg1" class="bgImng"
			></div>
			<div 
				v-else 
				id="bg2" class="bgImng" 
			></div>
		</div>

		<div id="bgRunning" v-if="currentState === STATE_RUNNING">
		</div>
		<div id="bgFinal" class="FS" v-if="currentState === STATE_SHOW_RESULT && showFinalText===true">
			<img class="finalImg" :src="finalImgName" />
		</div>
		
		<div 
			v-if="debug == true"
			class="debugWin"> {{ t }} </div>
		<div class="timeBuzzHeadline"> 
			<div id="timeContainer">
				{{timeToShow}}
			</div>
		</div>
		<div id="stopwatch" v-if="currentState  === STATE_SHOW_RESULT">
			{{yourTime}}
		</div>
	</div>
</template>
	
	
<script>

export default {
	name: 'TimeBuzzer',
	
	// props: ['timeToGo'],

	data() {
		return {
			debug: false,

			timeToShow: 0.00,
			yourTime: "22:00",
			timeToReach: 5000, 
			textToShow: "",
			text_infoOnStart: "PRESS BUZZER <br> TO START",
			text_ergebnis_perfekt: "wow ... PERFEKT !!!",
			text_ergebnis_schlecht: "nicht ganz ... gleich nochmal ",
			TEXT_RUNNING: "DIE ZEIT LÄUFT ",
			ergebnisText: "",
			endText: ["Knapp daneben!",
				"Das geht noch besser!",
				"Hoppla – verpasst!",
				"2. Versuch gefällig?",
				"Und jetzt das Ganze noch einmal",
				"Nächster Versuch?",
				"Auf ein Neues!",
				"Beim nächsten Mal klappts bestimmt!",
				"Aller Anfang ist schwer",
				"Ups - knapp daneben",
				"Probieren geht über studieren",
				"Es ist möglich. Mehr brauchst du nicht zu wissen.",
				"Haarscharf - vielleicht beim nächsten Mal?",
				"Eine neue Runde ist wie ein neues Leben",
				"Es ist noch kein Meister vom Himmel gefallen",
				"One more time"
			],

			/** Länge des Countdowns in Millisekunden */
			countdowntime : 5000,

			/** Anzeigemodi: 1 = Sekunden : Hundertstel, 2 = Minuten : Sekunden : Zehntel, 3 = Minuten : Sekunden,
			else Minuten : Sekunden : Hundertstel */
			modus : 1,
			/** Nur Anfangszeit (countdowntime) */
			COUNTMODE_NOCOUNT : 0,
			/** Countdown mit Anfangszeit (countdowntime) */
			COUNTMODE_DOWN : 1,
			/** Stoppuhr mit Endzeit (countdowntime) */
			COUNTMODE_UP : 2,
			/** Stoppuhr ohne Endzeit (endless) */
			COUNTMODE_UP_ENDLESS: 3,

			countMode: 0,


			STATE_WAIT_TO_START: 0,
			STATE_RUNNING: 1,
			STATE_SHOW_RESULT: 2,

			currentState: 0,

			timerInterval: null,
			toggleBgIntervall: null,
			showFinalText: false,

			/** Soundfile hier einfügen 
			Testsounds
			Horn (testsound_horn.wav):  https://assets.mixkit.co/sfx/download/mixkit-truck-horn-720.wav
			Flute (testsound_flute.wav): https://assets.mixkit.co/sfx/download/mixkit-melodical-flute-music-notification-2310.wav
			*/
			soundfile: '/snd/testsound_flute.wav',

			/** sound auf true setzten, um Soundfile abzuspielen */
			sound : true,
			
			t : -1,

			minuten : -1,
			sekunden : -1, 
			zehntel: -1,  
			hundertstel: -1,
			restzeit : -1, 
			startzeit : -1,

			deltaT: 0,

			timeToGo: 5,
			bgIntervalTime: 700,
			
			showBg1: true,

			finalImgName: "",
		}
	},

	/** Count-Mode hier einstellen (s.o) */
	created () {
		console.log(" -> created -> time in sec: " + this.timeToGo)
		if (!this.timeToGo) {
			// wenn keine zeit angegeben - nehme 5 sekungen ... 
			this.timeToGo = 5;
		} else {
			// remove unwant chars 
			// this.timeToGo = ( "" + this.timeToGo).replace(/^\D+/g, '');
		}
		this.countdowntime = this.timeToGo * 1000;

		this.timeToShow = this.zeroPad(Number(this.timeToGo), 1) + ":00"
	},

	mounted () {
		this.resetGame()
		this.addKeyDownListener()
		this.startBgToggle();
	},

	methods: {

		startBgToggle: function() {
			clearInterval(this.toggleBgIntervall);
			this.toggleBgIntervall = setInterval(this.toggleBG, this.bgIntervalTime);
		},

		toggleBG: function () {
				this.showBg1 = !this.showBg1;
		},

		zeroPad : (num, places) => String(num).padStart(places, '0'),

		startGAME: function() {
			this.startzeit = new Date().getTime();
			this.timerInterval = setInterval(this.countdown, 50);
		},

		/** Wird durch zweites Drücken von Leertaste oder Enter aufgerufen wenn Zeit verbleibt.
		Hält die Uhr an */
		stopGAME: function() {
			this.deltaT = Math.floor(Math.abs(this.t - this.timeToGo*1000) / 10);
			console.log(" -> stopGAME -> deltaT : " + this.deltaT);
			clearInterval(this.timerInterval);
			
			setTimeout(this.setFinalText, 1000);
		},

		toggleFinalText: function() {
			this.showFinalText = !this.showFinalText;
		},

		setFinalText: function () {
			this.finalImgName = this.getFinalText(this.deltaT);
			this.showFinalText = true;
			clearInterval(this.toggleBgIntervall);
			this.toggleBgIntervall = setInterval(this.toggleFinalText, this.bgIntervalTime);
		},

		getFinalText: function (_deltaT) {
			if (_deltaT == 0) {
				// PERFEKT 
				return "ST_Perfekt.png";
			}
			let id = Math.floor(Math.random() * 16) + 1;

			let retval = "/MAZ/ST" + id + ".png";
			console.log(" -> getFinalText ->  : " + retval);
			return retval;
		},

		resetGame: function() {
			this.currentState = this.STATE_WAIT_TO_START;
			this.t = 0;
			this.countMode = this.COUNTMODE_UP;
			this.textToShow = this.text_infoOnStart;
			this.deltaT = 0;
			this.ergebnisText = "";
			clearInterval(this.toggleBgIntervall);
			clearInterval(this.timerInterval);
			this.showFinalText = false;
			this.startBgToggle();
		},

		/** Wird durch die Funktion timer() aufgerufen.
		Zählt die Zeit und zeigt sie an */
		countdown() {
			const aktuellezeit = new Date().getTime(); 

			/* t = Zeit in Millisekunden
			Wenn countMode cauf COUNTMODE_UP oder COUNTMODE_UP_ENDLESS steht, wird t hoch gezählt, sonst runter */	
			if (this.countMode === this.COUNTMODE_UP || this.countMode === 3) {
				this.t = aktuellezeit - this.startzeit;
			} else {
				this.t = this.countdowntime + this.startzeit - aktuellezeit;
			}	
				
			if (this.sound === true) {
				new Audio(this.soundfile).play();
			}
			
			if (this.t <= 0 ) {
				this.t = 0
			}

			/* Darstellung der Zeit je nach Anzeigemodus */
			this.minuten = Math.floor(this.t/60000);
			this.sekunden = Math.floor((this.t - this.minuten * 60000) / 1000);
			this.zehntel = Math.floor((this.t - (this.minuten * 60000) - (this.sekunden * 1000)) / 100);
			this.hundertstel = Math.floor((this.t - (this.minuten * 60000) - (this.sekunden * 1000) - (this.zehntel * 100)) / 10);
			if (this.minuten < 10) {
				this.minuten = "0" + this.minuten;
			}
			
			if (this.sekunden < 10) { 
				// UiUiUi ... aus int wird string ... böse ... :)
				this.sekunden = "0" + this.sekunden;
			}
			if (this.modus === 1) {
				this.restzeit = this.sekunden + ":" + this.zehntel + this.hundertstel;
			} else if (this.modus === 2) {
				this.restzeit = this.minuten + ":" + this.sekunden + ":" + this.zehntel;
			} else if (this.modus === 3) {
				this.restzeit = this.minuten + ":" + this.sekunden;	
			} else {
				this.restzeit = this.minuten + ":" + this.sekunden + ":" + this.zehntel + this.hundertstel;
			}
		},

		/** Eventlistener, wird beim Mounten aufgerufen 
			je nach Status von "running" werden die Funktionen timer(), stopwatch() oder resetwatch() aufgerufen */
		addKeyDownListener: function()	{
			window.addEventListener("keydown", this.clickTapBuzz);
		},

		clickTapBuzz: function() {
			console.log(` -> clickTapBuzz () - currentState : ` + this.currentState);
			switch (this.currentState) {
				case this.STATE_WAIT_TO_START:
					this.startGAME();
					this.textToShow = this.TEXT_RUNNING;
					this.currentState++;
					break;
				case this.STATE_RUNNING:
					this.stopGAME();
					this.yourTime = this.zeroPad((this.t / 1000).toFixed(2), 5);
					this.yourTime = this.yourTime.replace(".",":")
					console.log(" - this.deltaT - this.deltaT" + this.deltaT)
					if (this.deltaT == 0) {
						this.ergebnisText = this.text_ergebnis_perfekt;
					} else {
						this.ergebnisText = this.text_ergebnis_schlecht;
					}
					// TODO :.. cgheck íf treffer ... 
					this.currentState++;
					break;
				case this.STATE_SHOW_RESULT:
					this.resetGame();
					this.currentState = this.STATE_WAIT_TO_START;
					break;
				default:
				}

			}
	} // end methods
}
</script>

<style scoped >

	.debugWin{
		position: absolute;
		right: 0;
		top: 5vh;
		width: 10vw;
		font-size: 2vh;
		color: aliceblue;
	}

	.bgImng {
		width: 100vw;
		height: 100vh;
	}


	
	#ergebnisContainer {
		font-size: 7vh;
		color: white;
		position: absolute;
		bottom: 20vh;
		margin: 0 0 0 15vw;
	}

	#bgContainer1{
		position: absolute;
		width: 100vw;
		height: 100vh;
		background-image: url("/MAZ/MZ_Start_ohneZeit.png");
		background-size: cover;
	}

	.FS {
		width: 100vw;
		height: 100vh;
		position: absolute;
		overflow: hidden;
	}

	.Screen {
		width: 100vw;
		height: 100vh;
	/*  "flex-start" für links, "center" für mittig und "flex-end" für rechts */
		justify-content: center;
	/*  "flex-start" für oben, "center" für mittig und "flex-end" für unten */	
		align-items: center;
	}

	/* Testbild: Eigene Ressourcen einfügen!
	https://www.pcclean.io/wp-content/uploads/2020/4/bMFzAr.jpg */
	#Screen {
		background-image: url("/MAZ/MZ_Zeitstopp.png");
		background-size: cover;
	}

	@font-face {
		font-family: DIN;
		src: url('/font/01_DIN_Next/DINNextLTPro-Bold.ttf');
	}

	/* Farben und Größe etc. für Stopuhr hier ändern: 
	Vordefinierte Farben z.B hier https://www.w3schools.com/colors/colors_names.asp */
	#stopwatch {
		position: absolute;
		font-family: DIN, sans-serif;
		color: #4f80ff;
		text-align: center;
		font-size: 13vw;
		top: 66vh;
		left: 48.5vw;
		font-weight: 700;
	}

	.timeBuzzHeadline {
		position: absolute;
		color: white;
		font-size: 7vh;
		top: 5vh;
		left: 0;
		width: 100vw;
		display: flex;
		align-content: center;
		flex-flow: nowrap;
		justify-content: center;
		flex-direction: row;
		align-items: center;
	}

	#timeContainer {
		position: absolute;
		padding-left: 7vw;
		top: 24vh;
		border-radius: 0vw;
		font-size: 10vh;
		width: 12vw;
		color: white;
		overflow: hidden;
		font-family: DIN, sans-serif;
	}

	#bg1 {
		background-image: url("/MAZ/MZ_Start_ohneZeit.png");
		background-size: cover;
	}
	#bg1 {
		background-image: url("/MAZ/MZ_Start_ohneZeit_II.png");
		background-size: cover;
	}

	#textContainer  {
		
	}

	#bgRunning {
		width: 100vw;
		height: 100vh;
		background-image: url("/MAZ/MZ_Zeitlaeuft.png");
		background-size: cover;
	}

	#bgFinal {
		z-index: 100;
	}

	.finalImg {
		width: 100vw;
	}

</style>

